import * as Yup from 'yup'

export function ValidateForm(values) {
    return Yup.object().shape({
        checkin_date: Yup.string().required('This field is required'),
        checkout_date: Yup.string().required('This field is required'),
        room_name: Yup.string().required('This field is required'),
        name: Yup.string().required('This field is required'),
        phone_number: Yup.string().required('This field is required'),
        email: Yup.string().email('Please enter a valid email').required('This field is required'),
    });
}
